$(document).on('click','.header-logo,.twl-sec-wrap a,.mob_link,.mnda-list a',function(){
  localStorage.setItem("scrollLast",0);
})
let page = __st.pageurl.split('/').pop();
let home = __st.p;
if(home.includes('home') || page.includes('about-us') || page.includes('news')){
  let locoScrollDefaults = {
      el: document.querySelector('[data-scroll-container]'),
      smooth: true,
      direction: "horizontal",
      multiplier: 1.5,
      tablet: {
        smooth: true,
        gestureDirection: 'horizontal',
        direction: 'horizontal',
        breakpoint: 991,
      },
  };
  let last_section = false
  let locoScroll = new LocomotiveScroll(locoScrollDefaults);
  gsap.registerPlugin(ScrollTrigger);
  locoScroll.on("scroll", (e) => {
    ScrollTrigger.update
    logoShrink(e);
    var windowwidth = $(window).width();
    // setTimeout(() => {
    //   if(window.location.href.indexOf('#ContactFooter') > '1'){
    //     console.log('innn');
    //     setTimeout(() => {locoScroll.destroy();}, 0);
    //     setTimeout(() => {locoScroll.init();}, 500);
    //     setTimeout(() => {locoScroll.update();}, 1000);
    //   }
    // }, 3500);
    $('body.svg_cls_anim main div.shopify-section').each(function(){
      if($(this).hasClass('text-with-link-main')){
        last_section = true
      }
    });
    if(windowwidth > 991){
      if(window.location.href.indexOf('una-nz') > -1){
        localStorage.setItem("scrollLast", e.delta.x);
      }else{
        localStorage.setItem("scrollLast",0);
      }
      let last_sec = e.limit.x - ($('.header-logo svg').width()*2);
      if(last_sec <= e.delta.x){
        if(last_section){
          if(page != 'news'){
            $('body').addClass('scroll-end');
            // setTimeout(() => {locoScroll.destroy();}, 0);
            // setTimeout(() => {locoScroll.init();}, 500);
            // setTimeout(() => {locoScroll.update();}, 1000);
          }
        }
      }else if(last_sec >= e.delta.x){
        if(page != 'news') $('body').removeClass('scroll-end');
      }
      
      $('.parallax-img').each(function(){
        if($(this).offset().left < e.delta.x){
          var difference = e.delta.x - $(this).offset().left;
          var half = (difference / 10) + 'px',
          transform = 'translate3d('+half+',0,0)';
          $(this).find('img').css('transform', transform);
        }else{
          $(this).find('img').css('transform', 'translate3d(0,0,0)');
        }
      });
    }
  });
  ScrollTrigger.scrollerProxy(".smoothScroll", {
    scrollTop(value) {
      return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.y;
    },
    scrollLeft(value) {
      return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.x;
    },
    getBoundingClientRect() {
      return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
    },
    pinType: document.querySelector(".smoothScroll").style.transform ? "transform" : "fixed"
  });
  function logoShrink(e){
    var widnowHeight = e.limit.x / 2;
    var windowwidth = $(window).width();
    if($('.svg_cls_anim').length > 0){
      if(windowwidth > 991){
        var scrolltop = e.delta.x;
        var cn = (100 - (scrolltop/(widnowHeight)*250));
        $('.logobar .header-logo svg').css({'width': 'calc('+ cn +'% - 80px)'});
        var log_scroll = 0
      }
      if(cn <= 60 && log_scroll <= 0){
        cn = 1;
        $('body').removeClass('colorSVG');
      }else{
        $('body').addClass('colorSVG');
      }
    }
  }

  function removeScroll(){
    var windowwidth = $(window).width();
    if(windowwidth < 992){
      setTimeout(() => {locoScroll.destroy();}, 0);
      setTimeout(() => {locoScroll.update();}, 1000);
    }
  }
  $(window).on('load',function(){removeScroll();});
  $(window).on('resize',function(){removeScroll();});
  if($(window).width() > 991){
    if(localStorage.getItem("scrollLast") != null){
      var previousPageURL = document.referrer;
      console.log('Previous Page URL:', previousPageURL);
      if (previousPageURL.includes('https://una-nz.myshopify.com')) {
        locoScroll.scrollTo(parseInt(localStorage.getItem("scrollLast")));
      }
    }
  }
  
}
  // $(window).on('popstate', function(event){
  //   var href = event.target.location.href;
  //   var domainURL = event.target.location.hostname;
  //   var shopURL = window.location.hostname;
  //   alert('href.charAt(0)',href,'---',domainURL);
  //   if(href.charAt(0) != '#'){
  //     if($(window).width() > 991){
  //       if(localStorage.getItem("scrollLast") != null){
  //         locoScroll.scrollTo(parseInt(localStorage.getItem("scrollLast")));
  //       }
  //     }
  //   }
  // })
// window.addEventListener("popstate", (event) => {
//   console.log(
//     `location: ${document.location}, state: ${JSON.stringify(event.state)}`,
//   );
// });
$(window).on('scroll',function(){
  var windowWidth = $(window).width();
  var scrollCount = $(document).scrollTop(); 
  if(windowWidth < 992){
    if(scrollCount > 0){
      $('body').addClass('active');
    }else{
      $('body').removeClass('active');
    }
  }
});
$('.mb-parallax img').each(function(){
  var img = $(this);
  var imgParent = $(this).parent();
  function parallaxImg () {
    var speed = 0.75;
    var imgY = imgParent.offset().top;
    var winY = $(this).scrollTop();
    var winH = $(this).height();
    var parentH = imgParent.innerHeight();
    var winBottom = winY + winH;
    if (winBottom > imgY && winY < imgY + parentH) {
      var imgBottom = ((winBottom - imgY) * speed);
      var imgTop = winH + parentH;
      var imgPercent = ((imgBottom / imgTop) * 100) + (50 - (speed * 110));      
    }
    img.css({
      top: imgPercent + '%',
      transform: 'translate(0%, ' + imgPercent + '%)'
    });
  }
  $(document).on({
    scroll: function () {
      parallaxImg();
    }, ready: function () {
      parallaxImg();
    }
  });
});